var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinHorecaLtr = function SvgPinHorecaLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M50 0c18.225 0 33 14.905 33 33.29 0 5.503-1.327 10.82-3.83 15.578-1.55 2.952-4.696 8.818-9.06 16.912l-8.737 16.172-9.056 16.713c-1.052 1.807-3.677 1.779-4.68-.082L20.854 48.914A33.4 33.4 0 0 1 17 33.29C17 14.904 31.775 0 50 0M36 17v10.938q0 2.315 1.39 4.051a6.46 6.46 0 0 0 3.532 2.284V52h3.281V34.273a6.46 6.46 0 0 0 3.532-2.284q1.39-1.736 1.39-4.052V17h-3.281v10.938h-1.64V17h-3.282v10.938h-1.64V17zm26.25 0q-3.63 0-6.19 2.56t-2.56 6.19v10.938h5.469V52h3.281z",
    clipRule: "evenodd"
  })));
};
export default SvgPinHorecaLtr;